import fetchAPI from '../../../lib/utils/fetch-api'
import { Poll } from './types'

export async function getAdminPolls(): Promise<Poll[]> {
  const response = await fetchAPI('/api/dealers/admin/polls')
  return response.data || []
}

export async function createAdminPoll(payload: Record<string, unknown>) {
  const response = await fetchAPI('/api/dealers/admin/polls', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
  return response.data
}

export async function updateAdminPoll(pollId: string, payload: Record<string, unknown>) {
  const response = await fetchAPI(`/api/dealers/admin/polls/${pollId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  })
  return response.data
}

export async function getAdminPoll(pollId: string): Promise<Poll | null> {
  const response = await fetchAPI(`/api/dealers/admin/polls/${pollId}`)
  return response.data || null
}

export async function getAdminPollDefinition(pollId: string): Promise<Poll | null> {
  const response = await fetchAPI(`/api/dealers/admin/polls/${pollId}/definition`)
  return response.data || null
}

export async function getAdminSteps(quizId: string) {
  const response = await fetchAPI(`/api/dealers/admin/polls/${quizId}/steps`)
  return response.data || []
}

export async function createAdminStep(quizId: string, payload: Record<string, unknown>) {
  const response = await fetchAPI(`/api/dealers/admin/polls/${quizId}/steps`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
  return response.data
}

export async function updateAdminStep(
  quizId: string,
  stepId: string,
  payload: Record<string, unknown>,
) {
  const response = await fetchAPI(`/api/dealers/admin/polls/${quizId}/steps/${stepId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  })
  return response.data
}

export async function deleteAdminStep(quizId: string, stepId: string) {
  const response = await fetchAPI(`/api/dealers/admin/polls/${quizId}/steps/${stepId}`, {
    method: 'DELETE',
  })
  return response.data
}

export async function createAdminQuestion(quizId: string, payload: Record<string, unknown>) {
  const response = await fetchAPI(`/api/dealers/admin/polls/${quizId}/questions`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
  return response.data
}

export async function updateAdminQuestion(
  quizId: string,
  questionId: string,
  payload: Record<string, unknown>,
) {
  const response = await fetchAPI(`/api/dealers/admin/polls/${quizId}/questions/${questionId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  })
  return response.data
}

export async function deleteAdminQuestion(quizId: string, questionId: string) {
  const response = await fetchAPI(`/api/dealers/admin/polls/${quizId}/questions/${questionId}`, {
    method: 'DELETE',
  })
  return response.data
}

export async function createAdminOption(
  quizId: string,
  questionId: string,
  payload: Record<string, unknown>,
) {
  const response = await fetchAPI(
    `/api/dealers/admin/polls/${quizId}/questions/${questionId}/options`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  )
  return response.data
}

export async function updateAdminOption(
  quizId: string,
  questionId: string,
  optionId: string,
  payload: Record<string, unknown>,
) {
  const response = await fetchAPI(
    `/api/dealers/admin/polls/${quizId}/questions/${questionId}/options/${optionId}`,
    {
      method: 'PUT',
      body: JSON.stringify(payload),
    },
  )
  return response.data
}

export async function deleteAdminOption(quizId: string, questionId: string, optionId: string) {
  const response = await fetchAPI(
    `/api/dealers/admin/polls/${quizId}/questions/${questionId}/options/${optionId}`,
    {
      method: 'DELETE',
    },
  )
  return response.data
}

export async function reorderAdminSteps(quizId: string, stepIds: string[]) {
  const response = await fetchAPI(`/api/dealers/admin/polls/${quizId}/steps/reorder`, {
    method: 'PUT',
    body: JSON.stringify({ step_ids: stepIds }),
  })
  return response.data
}

export async function reorderAdminQuestions(quizId: string, questionIds: string[]) {
  const response = await fetchAPI(`/api/dealers/admin/polls/${quizId}/questions/reorder`, {
    method: 'PUT',
    body: JSON.stringify({ question_ids: questionIds }),
  })
  return response.data
}

export async function reorderAdminOptions(questionId: string, optionIds: string[]) {
  const response = await fetchAPI(
    `/api/dealers/admin/polls/questions/${questionId}/options/reorder`,
    {
      method: 'POST',
      body: JSON.stringify({ option_ids: optionIds }),
    },
  )
  return response.data
}

export async function getAdminSubmissions(quizId?: string) {
  const url = quizId
    ? `/api/dealers/admin/polls/submissions?quiz_id=${encodeURIComponent(quizId)}`
    : '/api/dealers/admin/polls/submissions'
  const response = await fetchAPI(url)
  return response.data || []
}
